import http from "@/services/http";

export default function (Vue) {
  Vue.http = http;
  window.http = http;
  Object.defineProperties(Vue.prototype, {
    http: {
      get() {
        return http;
      }
    },
    $http: {
      get() {
        return http;
      }
    }
  });
}
